const judgingAdvising = [
  {
    title: 'Judge \u2014 RocketHacks, University of Toledo',
    description:
      "Judged student teams building Hack for Good projects across sustainability, accessibility, and financial literacy. Returned to Toledo to support the university's growing focus on tech innovation across industries.",
    linkLabel: 'View Post →',
    url:
      'https://www.linkedin.com/posts/rocket-hacks_this-weekend-i-had-the-opportunity-to-judge-ugcPost-7307847512759959553-FD7K?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA56CmABt_QI-ZXgbQvQPaqejKiFdbGhk9E',
  },
  {
    title: 'Guest Speaker & Judge \u2014 Brooklyn Technical High School Hackathon',
    description:
      "Judged and spoke at a student hackathon hosted by Brooklyn Tech's Girls Who Code chapter, in collaboration with the National Society of Black Engineers (NSBE) and TechCodes. Invited by student organizer Ashley Leung. A full-circle moment: Courtney was a beneficiary of NSBE and Girls Who Code programming during her own college years.",
    linkLabel: 'View Post →',
    url:
      'https://www.linkedin.com/posts/courtney-greer_i-had-the-incredible-privilege-this-past-activity-7160789540457103360-lEmX?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA56CmABt_QI-ZXgbQvQPaqejKiFdbGhk9E',
  },
];

export default judgingAdvising;
